module.exports = {
  USER_NOT_FOUND: 'user.not.found',
  EXPIRED_TOKEN: 'expired.token.message',
  INVALID_TOKEN: 'invalid.token.message',
};
